import React, { Component } from 'react';
import { Image } from 'semantic-ui-react'
import { base, } from '../../../../config/constants';

class ViewImageNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageList: []
        }
    }

    getImageNotes = () => {
        console.log("+++++++++ getImageNotes");
        console.log("orderKey:"+this.props.match.params.orderKey);
        //GET THE ORDER
        base.fetch('orders/' + this.props.match.params.orderKey + '/imageNotes', {
            context: this,
           
            asArray: true,
            then(data) {
                console.log(data);
                this.setState({
                    imageList: data
                })
            }
        });
    }
    
    componentDidMount () {
        console.log("+++++++++ componentDidMount");

        this.getImageNotes();
    }

    render() {

        const imageList = this.state.imageList.map((imageNote) =>
            <Image src={imageNote.imageNoteUrl} fluid centered bordered shape='rounded' />
        )

        return (<div>
            <h1>Image Notes for:{this.props.match.params.orderKey}</h1>
            {imageList}
           </div>);
    }
}

export default ViewImageNotes;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ImageNotes/ViewImageNotes.js